import { requireChatResponse } from './chat-response.mjs'

/** 请求失败与空列表必须区分：只有服务端明确成功，才能替换页面已有的协助会话。 */
export function readCooperationSessions(response) {
  const { data } = requireChatResponse(response, '读取协助空间失败，请稍后重试')
  return Array.isArray(data) ? data.filter(item => item?.lunciInfo != null) : []
}
